module.exports = __webpack_public_path__ + "static/featuredblock2-19e7225d0a8e686e6761858e5b229ca2.jpg";